import { render } from "./answerCardDownload.vue?vue&type=template&id=6e9d8da2&scoped=true"
import script from "./answerCardDownload.vue?vue&type=script&lang=js"
export * from "./answerCardDownload.vue?vue&type=script&lang=js"

import "./answerCardDownload.vue?vue&type=style&index=0&id=6e9d8da2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e9d8da2"]])

export default __exports__